import { FC, useState } from 'react'
import { YhBox } from '@/components/YhBox'
import { Tabs } from 'antd'
import { RouterParamType } from '@/model/navModel'
import { TableBox } from './TableBox'
import { usePurchaseEnquiryDetailsModel } from './purchaseEnquiryDetailsModel'
import { TableBoxChangeLog } from './TableBoxChangeLog'
import { TableBoxSupplier } from './TableBoxSupplier'


export const TabsBox: FC<RouterParamType> = (detailsInfo) => {

    const [tabActives, setTabActives] = useState<string>('InquiryList');
    const {
        detailAddForm, detailEditForm, detailLookForm,
    } = usePurchaseEnquiryDetailsModel();
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    return (
        <YhBox style={{ margin: '8px auto', padding: '0 10px', position: 'relative', height: 'calc(100vh - 740px)', minHeight: '720px', overflowY: "auto" }} >
            <Tabs defaultActiveKey={"InquiryList"} onChange={(e) => { setTabActives(e) }}>
                <Tabs.TabPane tab="询价清单" key="InquiryList">
                    <TableBox {...detailsInfo} />
                </Tabs.TabPane>
                {detailsInfo.mode !== 'add' && typeForm[detailsInfo.mode]?.status !== "purchase_enquiry.init" &&
                    <>
                        <Tabs.TabPane tab="供应商报价" key="supplierQuotation">
                            <TableBoxSupplier {...detailsInfo} />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="变更记录" key="changeLog">
                            <TableBoxChangeLog {...detailsInfo} />
                        </Tabs.TabPane>
                    </>
                }
            </Tabs>
        </YhBox>
    )
}
